import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/web.dom.iterable";
import _classCallCheck from "/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module autoformat/autoformat
 */
import BlockAutoformatEditing from "./blockautoformatediting";
import InlineAutoformatEditing from "./inlineautoformatediting";
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
/**
 * Enables a set of predefined autoformatting actions.
 *
 * For a detailed overview, check the {@glink features/autoformat Autoformatting feature documentation}
 * and the {@glink api/autoformat package page}.
 *
 * @extends module:core/plugin~Plugin
 */

var Autoformat =
/*#__PURE__*/
function (_Plugin) {
  _inherits(Autoformat, _Plugin);

  function Autoformat() {
    _classCallCheck(this, Autoformat);

    return _possibleConstructorReturn(this, _getPrototypeOf(Autoformat).apply(this, arguments));
  }

  _createClass(Autoformat, [{
    key: "afterInit",

    /**
     * @inheritDoc
     */
    value: function afterInit() {
      this._addListAutoformats();

      this._addBasicStylesAutoformats();

      this._addHeadingAutoformats();

      this._addBlockQuoteAutoformats();
    }
    /**
     * Adds autoformatting related to the {@link module:list/list~List}.
     *
     * When typed:
     * - `* ` or `- ` &ndash; A paragraph will be changed to a bulleted list.
     * - `1. ` or `1) ` &ndash; A paragraph will be changed to a numbered list ("1" can be any digit or a list of digits).
     *
     * @private
     */

  }, {
    key: "_addListAutoformats",
    value: function _addListAutoformats() {
      var commands = this.editor.commands;

      if (commands.get('bulletedList')) {
        // eslint-disable-next-line no-new
        new BlockAutoformatEditing(this.editor, /^[*-]\s$/, 'bulletedList');
      }

      if (commands.get('numberedList')) {
        // eslint-disable-next-line no-new
        new BlockAutoformatEditing(this.editor, /^1[.|)]\s$/, 'numberedList');
      }
    }
    /**
     * Adds autoformatting related to the {@link module:basic-styles/bold~Bold},
     * {@link module:basic-styles/italic~Italic} and {@link module:basic-styles/code~Code}.
     *
     * When typed:
     * - `**foobar**` &ndash; `**` characters are removed and `foobar` is set to bold,
     * - `__foobar__` &ndash; `__` characters are removed and `foobar` is set to bold,
     * - `*foobar*` &ndash; `*` characters are removed and `foobar` is set to italic,
     * - `_foobar_` &ndash; `_` characters are removed and `foobar` is set to italic,
     * - ``` `foobar` &ndash; ``` ` ``` characters are removed and `foobar` is set to code.
     *
     * @private
     */

  }, {
    key: "_addBasicStylesAutoformats",
    value: function _addBasicStylesAutoformats() {
      var commands = this.editor.commands;

      if (commands.get('bold')) {
        /* eslint-disable no-new */
        var boldCallback = getCallbackFunctionForInlineAutoformat(this.editor, 'bold');
        new InlineAutoformatEditing(this.editor, /(\*\*)([^*]+)(\*\*)$/g, boldCallback);
        new InlineAutoformatEditing(this.editor, /(__)([^_]+)(__)$/g, boldCallback);
        /* eslint-enable no-new */
      }

      if (commands.get('italic')) {
        /* eslint-disable no-new */
        var italicCallback = getCallbackFunctionForInlineAutoformat(this.editor, 'italic'); // The italic autoformatter cannot be triggered by the bold markers, so we need to check the
        // text before the pattern (e.g. `(?:^|[^\*])`).

        new InlineAutoformatEditing(this.editor, /(?:^|[^*])(\*)([^*_]+)(\*)$/g, italicCallback);
        new InlineAutoformatEditing(this.editor, /(?:^|[^_])(_)([^_]+)(_)$/g, italicCallback);
        /* eslint-enable no-new */
      }

      if (commands.get('code')) {
        /* eslint-disable no-new */
        var codeCallback = getCallbackFunctionForInlineAutoformat(this.editor, 'code');
        new InlineAutoformatEditing(this.editor, /(`)([^`]+)(`)$/g, codeCallback);
        /* eslint-enable no-new */
      }
    }
    /**
     * Adds autoformatting related to {@link module:heading/heading~Heading}.
     *
     * It is using a number at the end of the command name to associate it with the proper trigger:
     *
     * * `heading` with value `heading1` will be executed when typing `#`,
     * * `heading` with value `heading2` will be executed when typing `##`,
     * * ... up to `heading6` and `######`.
     *
     * @private
     */

  }, {
    key: "_addHeadingAutoformats",
    value: function _addHeadingAutoformats() {
      var _this = this;

      var command = this.editor.commands.get('heading');

      if (command) {
        command.modelElements.filter(function (name) {
          return name.match(/^heading[1-6]$/);
        }).forEach(function (commandValue) {
          var level = commandValue[7];
          var pattern = new RegExp("^(#{".concat(level, "})\\s$")); // eslint-disable-next-line no-new

          new BlockAutoformatEditing(_this.editor, pattern, function () {
            if (!command.isEnabled) {
              return false;
            }

            _this.editor.execute('heading', {
              value: commandValue
            });
          });
        });
      }
    }
    /**
     * Adds autoformatting related to {@link module:block-quote/blockquote~BlockQuote}.
     *
     * When typed:
     * * `> ` &ndash; A paragraph will be changed to a block quote.
     *
     * @private
     */

  }, {
    key: "_addBlockQuoteAutoformats",
    value: function _addBlockQuoteAutoformats() {
      if (this.editor.commands.get('blockQuote')) {
        // eslint-disable-next-line no-new
        new BlockAutoformatEditing(this.editor, /^>\s$/, 'blockQuote');
      }
    }
  }], [{
    key: "pluginName",

    /**
     * @inheritDoc
     */
    get: function get() {
      return 'Autoformat';
    }
  }]);

  return Autoformat;
}(Plugin); // Helper function for getting `InlineAutoformatEditing` callbacks that checks if command is enabled.
//
// @param {module:core/editor/editor~Editor} editor
// @param {String} attributeKey
// @returns {Function}


export { Autoformat as default };

function getCallbackFunctionForInlineAutoformat(editor, attributeKey) {
  return function (writer, rangesToFormat) {
    var command = editor.commands.get(attributeKey);

    if (!command.isEnabled) {
      return false;
    }

    var validRanges = editor.model.schema.getValidRanges(rangesToFormat, attributeKey);
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = validRanges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var range = _step.value;
        writer.setAttribute(attributeKey, true, range);
      } // After applying attribute to the text, remove given attribute from the selection.
      // This way user is able to type a text without attribute used by auto formatter.

    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    writer.removeSelectionAttribute(attributeKey);
  };
}